<template>
    <div style="height: 100%;overflow:auto;">
        <div class="remote-control-simulator">
            <div class="header">
                <h2>TBOX远程控制终端模拟工具（MQTT完整版）</h2>
                <p class="subtitle">指令回复 + 全字段状态上报</p>
            </div>

            <!-- MQTT连接区 -->
            <div class="mqtt-connect-box">
                <el-form :model="mqttConfig" inline label-width="100px">
                    <el-form-item label="MQTT连接状态">
                        <el-tag :type="mqttConnected ? 'success' : 'danger'">
                            {{ mqttConnected ? '已连接' : '未连接' }}
                        </el-tag>
                    </el-form-item>
                    <el-form-item label="设备编号">
                        <el-input v-model="mqttConfig.deviceNo" placeholder="DeviceNo" style="width:160px" />
                    </el-form-item>
                  
                    <el-form-item>
                        <el-button type="primary" @click="connectMQTT" :loading="connectLoading">连接MQTT</el-button>
                        <el-button @click="disconnectMQTT" :disabled="!mqttConnected">断开连接</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="main-container">
                <!-- 左侧：终端指令回复 -->
                <div class="left-panel">
                    <div class="panel-title">
                        <i class="el-icon-message" /> 远程控制终端指令回复
                    </div>
                    <div class="panel-content">
                        <el-form :model="replyForm" label-width="120px" class="simulator-form">
                            <el-form-item label="CmdID">
                                <el-input v-model="replyForm.CmdID" placeholder="指令ID" />
                            </el-form-item>
                            <el-form-item label="Result">
                                <el-radio-group v-model="replyForm.Result">
                                    <el-radio label="1">成功(1)</el-radio>
                                    <el-radio label="0">失败(0)</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="Status">
                                <el-select v-model="replyForm.Status" placeholder="执行状态">
                                    <el-option label="等待中" value="1" />
                                    <el-option label="执行中" value="2" />
                                    <el-option label="执行结束" value="3" />
                                    <el-option label="关闭" value="4" />
                                    <el-option label="异常" value="5" />
                                    <el-option label="任务取消成功" value="6" />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Msg" v-if="replyForm.Result === '0'">
                                <el-input v-model="replyForm.Msg" type="textarea" :rows="2" placeholder="失败原因" />
                            </el-form-item>
                            <el-form-item label="TboxLocalFail" v-if="replyForm.Result === '0'">
                                <el-select v-model="replyForm.TboxLocalFail">
                                    <el-option label="非TBOX失败" value="0" />
                                    <el-option label="空调本地模式" value="1" />
                                    <el-option label="仪表本地模式" value="2" />
                                    <el-option label="后舱门开启" value="3" />
                                    <el-option label="手刹松开" value="4" />
                                    <el-option label="存在刹车信号" value="5" />
                                    <el-option label="档位异常" value="6" />
                                    <el-option label="存在油门信号" value="7" />
                                    <el-option label="车速>2km/h" value="8" />
                                    <el-option label="ACC开启" value="9" />
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="sendReplyMQTT" :loading="replyLoading"
                                    :disabled="!mqttConnected">
                                    发送终端应答
                                </el-button>
                                <el-button @click="resetReplyForm">重置</el-button>
                            </el-form-item>
                        </el-form>

                        <div class="log-container">
                            <div class="log-title">应答日志</div>
                            <div class="log-content" ref="replyLogRef">
                                <div v-for="(item, idx) in replyLogs" :key="idx" class="log-item">
                                    <span class="log-time">{{ item.time }}</span>
                                    <span :class="item.result === '1' ? 'log-success' : 'log-error'">
                                        {{ item.result === '1' ? '[成功]' : '[失败]' }}
                                    </span>
                                    {{ item.content }}
                                </div>
                                <div v-if="replyLogs.length === 0" class="empty-log">暂无记录</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧：状态上报（全字段） -->
                <div class="right-panel">
                    <div class="panel-title">
                        <i class="el-icon-data-line" /> 远程控制状态上报（全字段）
                    </div>
                    <div class="panel-content">
                        <el-tabs v-model="activeTab" type="card">

                            <!-- 基础状态 -->
                            <el-tab-pane label="基础状态" name="basic">
                                <el-form :model="statusForm" label-width="160px">
                                    <el-form-item label="MsgID">
                                        <el-input v-model="statusForm.MsgID" placeholder="消息ID" />
                                    </el-form-item>
                                    <el-form-item label="空调开关(ACSwitch)">
                                        <el-radio-group v-model="statusForm.ACSwitch">
                                            <el-radio label="1">开启</el-radio>
                                            <el-radio label="0">关闭</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="空调剩余时间(秒)">
                                        <el-input v-model="statusForm.ACRemainingTime" style="width:160px" />
                                    </el-form-item>
                                    <el-form-item label="双闪灯(ELightSwitch)">
                                        <el-radio-group v-model="statusForm.ELightSwitch">
                                            <el-radio label="1">开启</el-radio>
                                            <el-radio label="0">关闭</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="双闪剩余时间(秒)">
                                        <el-input v-model="statusForm.ELightRemainingTime" style="width:160px" />
                                    </el-form-item>
                                    <el-form-item label="换气扇(FanSwitch)">
                                        <el-radio-group v-model="statusForm.FanSwitch">
                                            <el-radio label="1">开启</el-radio>
                                            <el-radio label="0">关闭</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="换气扇剩余时间(秒)">
                                        <el-input v-model="statusForm.FanRemainingTime" style="width:160px" />
                                    </el-form-item>
                                    <el-form-item label="司机灯(DLightSwitch)">
                                        <el-radio-group v-model="statusForm.DLightSwitch">
                                            <el-radio label="1">开启</el-radio>
                                            <el-radio label="0">关闭</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="司机灯剩余时间(秒)">
                                        <el-input v-model="statusForm.DLightRemainingTime" style="width:160px" />
                                    </el-form-item>
                                    <el-form-item label="车内温度(InCarTemp)">
                                        <el-input v-model="statusForm.InCarTemp" style="width:160px" />
                                    </el-form-item>
                                    <el-form-item label="功能配置状态(ConfigStatus)">
                                        <el-input v-model="statusForm.ConfigStatus" placeholder="例：1FFF"
                                            style="width:160px" />
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>

                            <!-- 空调参数 -->
                            <el-tab-pane label="空调参数" name="ac">
                                <el-form :model="statusForm" label-width="160px">
                                    <el-form-item label="空调模式(ACMode)">
                                        <el-select v-model="statusForm.ACMode" style="width:200px">
                                            <el-option label="通风" value="0" />
                                            <el-option label="暖风" value="1" />
                                            <el-option label="制冷" value="2" />
                                            <el-option label="再加热" value="3" />
                                            <el-option label="除霜" value="4" />
                                            <el-option label="自动" value="5" />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="蒸发机风量(EvaporatorFan)">
                                        <el-select v-model="statusForm.EvaporatorFan" style="width:200px">
                                            <el-option label="关闭" value="0" />
                                            <el-option label="1档" value="1" />
                                            <el-option label="2档" value="2" />
                                            <el-option label="3档" value="3" />
                                            <el-option label="4档" value="4" />
                                            <el-option label="5档" value="5" />
                                            <el-option label="自动" value="6" />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="设定温度(TargetACTemp)">
                                        <el-input v-model="statusForm.TargetACTemp" placeholder="17-27"
                                            style="width:160px" />
                                    </el-form-item>
                                    <el-form-item label="吹风模式(FanModeSet)">
                                        <el-select v-model="statusForm.FanModeSet" style="width:200px">
                                            <el-option label="无效" value="0x00" />
                                            <el-option label="吹脸" value="0x01" />
                                            <el-option label="吹脚" value="0x02" />
                                            <el-option label="除霜" value="0x03" />
                                        </el-select>
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>

                            <!-- 加热/散热/除霜 -->
                            <el-tab-pane label="加热散热" name="heat">
                                <el-form :model="statusForm" label-width="180px">
                                    <el-form-item label="燃油加热器(FuelHeaterSwitch)">
                                        <el-radio-group v-model="statusForm.FuelHeaterSwitch">
                                            <el-radio label="1">开启</el-radio>
                                            <el-radio label="0">关闭</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="燃油加热器剩余时间(秒)">
                                        <el-input v-model="statusForm.FuelHeaterRemainingTime"
                                            style="width:160px" />
                                    </el-form-item>

                                    <el-form-item label="后视镜加热(MirrorHeaterSwitch)">
                                        <el-radio-group v-model="statusForm.MirrorHeaterSwitch">
                                            <el-radio label="1">开启</el-radio>
                                            <el-radio label="0">关闭</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="后视镜加热剩余时间(秒)">
                                        <el-input v-model="statusForm.MirrorHeaterRemainingTime"
                                            style="width:160px" />
                                    </el-form-item>

                                    <el-form-item label="暖风散热器(RadiatorSwitch)">
                                        <el-radio-group v-model="statusForm.RadiatorSwitch">
                                            <el-radio label="1">开启</el-radio>
                                            <el-radio label="0">关闭</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="散热器剩余时间(秒)">
                                        <el-input v-model="statusForm.RadiatorRemainingTime"
                                            style="width:160px" />
                                    </el-form-item>

                                    <el-form-item label="除霜机(DeFrostSwitch)">
                                        <el-radio-group v-model="statusForm.DeFrostSwitch">
                                            <el-radio label="1">开启</el-radio>
                                            <el-radio label="0">关闭</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item label="除霜机剩余时间(秒)">
                                        <el-input v-model="statusForm.DeFrostRemainingTime"
                                            style="width:160px" />
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>

                            <!-- 电池热管理 -->
                            <el-tab-pane label="电池热管理" name="battery">
                                <el-form :model="statusForm" label-width="180px">
                                    <el-form-item label="电池预热开关">
                                        <el-select v-model="statusForm.BatteryPreheatingSwitch" style="width:200px">
                                            <el-option label="等待" value="00" />
                                            <el-option label="预热中" value="01" />
                                            <el-option label="预热结束" value="02" />
                                            <el-option label="无效" value="03" />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="电池预热剩余时间(秒)">
                                        <el-input v-model="statusForm.BatteryPreheatingTime"
                                            style="width:160px" />
                                    </el-form-item>
                                    <el-form-item label="电池预热目标温度">
                                        <el-input v-model="statusForm.BatteryPreheatingTemp"
                                            style="width:160px" />
                                    </el-form-item>

                                    <el-form-item label="电池预冷开关">
                                        <el-select v-model="statusForm.BatteryPrecoolingSwitch" style="width:200px">
                                            <el-option label="等待" value="00" />
                                            <el-option label="预冷中" value="01" />
                                            <el-option label="预冷结束" value="02" />
                                            <el-option label="无效" value="03" />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="电池预冷剩余时间(秒)">
                                        <el-input v-model="statusForm.BatteryPrecoolingTime"
                                            style="width:160px" />
                                    </el-form-item>
                                </el-form>
                            </el-tab-pane>

                        </el-tabs>

                        <div style="margin-top:20px;text-align:center">
                            <el-button type="primary" @click="sendStatusMQTT" :loading="statusLoading"
                                :disabled="!mqttConnected">
                                发送状态上报
                            </el-button>
                            <el-button @click="resetStatusForm">重置</el-button>
                        </div>

                        <div class="log-container" style="margin-top:20px">
                            <div class="log-title">状态上报日志</div>
                            <div class="log-content" ref="statusLogRef">
                                <div v-for="(item, idx) in statusLogs" :key="idx" class="log-item">
                                    <span class="log-time">{{ item.time }}</span>
                                    <span class="log-info">[上报]</span>
                                    {{ item.content }}
                                </div>
                                <div v-if="statusLogs.length === 0" class="empty-log">暂无记录</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mqtt-info">
                <div class="mqtt-title">MQTT协议信息</div>
                <div class="mqtt-content">
                    <p>服务地址：nac.kingwings.cn:4433</p>
                    <p>指令回复：RemoteControl/control/reply</p>
                    <p>状态上报：RemoteControl/status</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mqtt from 'mqtt'
import { getToken } from "@/utils/auth";
export default {
    name: 'RemoteControlSimulator',
    data() {
        return {
            mqttClient: null,
            mqttConnected: false,
            connectLoading: false,
            mqttConfig: {
                deviceNo: '002800000083',
                
                host: 'ws://ws.kingwings.cn/mqtt',
                // host: 'ws://172.20.2.19:8083/mqtt',
               // ws://127.0.0.1:8083/mqtt
                timeout: 5000,
                jwtToken: ''
            },

            // 终端应答
            replyForm: {
                CmdID: 'CMD_' + new Date().getTime(),
                Result: '1',
                Status: '3',
                Msg: '',
                TboxLocalFail: '0'
            },
            replyLoading: false,
            replyLogs: [],

            // 状态上报【全字段】
            statusForm: {
                //取最后4位作为MsgID
                MsgID:  new Date().getTime().toString().substring(9,13),
                ACSwitch: '0',
                ACMode: '0',
                EvaporatorFan: '0',
                TargetACTemp: '25',
                ACRemainingTime: '0',
                ELightSwitch: '0',
                ELightRemainingTime: '0',
                FanSwitch: '0',
                FanRemainingTime: '0',
                DLightSwitch: '0',
                DLightRemainingTime: '0',
                InCarTemp: '25',
                ConfigStatus: '1FFF',
                FanModeSet: '0x00',

                FuelHeaterSwitch: '0',
                FuelHeaterRemainingTime: '0',
                MirrorHeaterSwitch: '0',
                MirrorHeaterRemainingTime: '0',
                RadiatorSwitch: '0',
                RadiatorRemainingTime: '0',
                DeFrostSwitch: '0',
                DeFrostRemainingTime: '0',

                BatteryPreheatingSwitch: '00',
                BatteryPreheatingTime: '0',
                BatteryPreheatingTemp: '25',
                BatteryPrecoolingSwitch: '00',
                BatteryPrecoolingTime: '0'
            },
            activeTab: 'basic',
            statusLoading: false,
            statusLogs: []
        }
    },
    methods: {
        connectMQTT() {
            if (this.mqttConnected) return
            this.connectLoading = true
            const options = {
                connectTimeout: this.mqttConfig.timeout,
                clientId: 'web_simulator_' + Math.random().toString(16).substr(2, 10),
                username: this.mqttConfig.deviceNo,
                password: getToken()
            }
            this.mqttClient = mqtt.connect(this.mqttConfig.host, options)
            this.mqttClient.on('connect', () => {
                this.mqttConnected = true
                this.connectLoading = false
                this.$message.success('MQTT连接成功')
            })
            this.mqttClient.on('error', (err) => {
                console.error('MQTT error', err)
                this.connectLoading = false
                this.$message.error('MQTT连接失败')
            })
            this.mqttClient.on('close', () => {
                this.mqttConnected = false
            })
        },
        disconnectMQTT() {
            if (this.mqttClient) {
                this.mqttClient.end()
                this.mqttConnected = false
                this.$message.info('已断开MQTT')
            }
        },
        sendReplyMQTT() {
            if (!this.mqttConnected) return this.$message.warning('请先连接MQTT')
            this.replyLoading = true
            const payload = {
                CmdID: this.replyForm.CmdID,
                Result: this.replyForm.Result,
                Msg: this.replyForm.Result === '1' ? '执行成功' : this.replyForm.Msg,
                DeviceNo: this.mqttConfig.deviceNo,
                TboxLocalFail: this.replyForm.TboxLocalFail,
                Status: this.replyForm.Status
            }
            this.mqttClient.publish('RemoteControl/control/reply', JSON.stringify(payload), { qos: 0 }, (err) => {
                this.replyLoading = false
                if (err) {
                    this.$message.error('发送失败：' + err.message)
                } else {
                    this.$message.success('发送成功')
                    this.replyLogs.unshift({
                        time: new Date().toLocaleString(),
                        result: payload.Result,
                        content: JSON.stringify(payload, null, 2)
                    })
                    if (this.replyLogs.length > 20) this.replyLogs = this.replyLogs.slice(0, 20)
                }
            })
        },
        sendStatusMQTT() {
            if (!this.mqttConnected) return this.$message.warning('请先连接MQTT')
            this.statusLoading = true
            const payload = {
                data: { ...this.statusForm },
                DeviceNo: this.mqttConfig.deviceNo,
                MsgID: this.statusForm.MsgID
            }
            this.mqttClient.publish('RemoteControl/status', JSON.stringify(payload), { qos: 0 }, (err) => {
                this.statusLoading = false
                if (err) {
                    this.$message.error('上报失败：' + err.message)
                } else {
                    this.$message.success('上报成功')
                    this.statusLogs.unshift({
                        time: new Date().toLocaleString(),
                        content: JSON.stringify(payload, null, 2)
                    })
                    if (this.statusLogs.length > 20) this.statusLogs = this.statusLogs.slice(0, 20)
                }
            })
        },
        resetReplyForm() {
            this.replyForm = {
                CmdID: 'CMD_' + new Date().getTime(),
                Result: '1',
                Status: '3',
                Msg: '',
                TboxLocalFail: '0'
            }
        },
        resetStatusForm() {
            this.statusForm = {
                //取最后4位作为MsgID
                MsgID:  new Date().getTime().toString().substring(9,13),
                ACSwitch: '0',
                ACMode: '0',
                EvaporatorFan: '0',
                TargetACTemp: '25',
                ACRemainingTime: '0',
                ELightSwitch: '0',
                ELightRemainingTime: '0',
                FanSwitch: '0',
                FanRemainingTime: '0',
                DLightSwitch: '0',
                DLightRemainingTime: '0',
                InCarTemp: '25',
                ConfigStatus: '1FFF',
                FanModeSet: '0x00',
                FuelHeaterSwitch: '0',
                FuelHeaterRemainingTime: '0',
                MirrorHeaterSwitch: '0',
                MirrorHeaterRemainingTime: '0',
                RadiatorSwitch: '0',
                RadiatorRemainingTime: '0',
                DeFrostSwitch: '0',
                DeFrostRemainingTime: '0',
                BatteryPreheatingSwitch: '00',
                BatteryPreheatingTime: '0',
                BatteryPreheatingTemp: '25',
                BatteryPrecoolingSwitch: '00',
                BatteryPrecoolingTime: '0'
            }
        }
    },
    beforeDestroy() {
        if (this.mqttClient) this.mqttClient.end()
    }
}
</script>

<style scoped>
/* 核心修复：去掉min-height:100vh，改为正常流式布局，页面可滚动 */
.remote-control-simulator {
    padding: 20px;
    background-color: #f5f7fa;
}

.header {
    text-align: center;
    margin-bottom: 20px;
}

.mqtt-connect-box {
    background: #fff;
    padding: 15px 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.main-container {
    display: flex;
    gap: 20px;
}

.left-panel,
.right-panel {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.panel-title {
    background: #409eff;
    color: #fff;
    padding: 12px 20px;
    font-weight: bold;
}

.panel-content {
    padding: 20px;
}

.log-container {
    border: 1px solid #eee;
    border-radius: 4px;
    margin-top: 15px;
}

.log-title {
    padding: 8px 12px;
    background: #f8f8f8;
    font-weight: bold;
    border-bottom: 1px solid #eee;
}

.log-content {
    height: 220px;
    overflow-y: auto;
    padding: 10px;
    font-size: 12px;
    font-family: monospace;
    background: #fafafa;
}

.log-item {
    margin-bottom: 6px;
    line-height: 1.4;
}

.log-time {
    color: #999;
    margin-right: 8px;
}

.log-success {
    color: #00c48c;
    font-weight: bold;
}

.log-error {
    color: #f56c6c;
    font-weight: bold;
}

.log-info {
    color: #409eff;
    font-weight: bold;
}

.empty-log {
    text-align: center;
    color: #ccc;
    padding: 20px 0;
}

.mqtt-info {
    background: #fff;
    padding: 15px 20px;
    border-radius: 8px;
    margin-top: 20px;
}

@media (max-width: 1200px) {
    .main-container {
        flex-direction: column;
    }
}
</style>